import PropTypes from 'prop-types';
import { useVipSpend } from '@/hooks/useVipCustomers';
import { VipPill } from '@/components/admin/VipBadge';

/**
 * On a VIP's trip page, for staff (founder, 2026-10-25): a reminder that this
 * customer is a good candidate for a complimentary upgrade, while the trip
 * is active, still ahead and not upgraded already. The upgrade itself is
 * the existing admin edit (Edit trip, then "Upgraded"), which emails them.
 * Renders nothing for anyone else (src/hooks/useVipCustomers.js).
 */
export default function VipUpgradeNudge({ userId, upgraded = false, active = false }) {
  const spend = useVipSpend({ userId });
  if (spend == null || upgraded || !active) return null;
  return (
    <div className="mt-3 flex items-start gap-2.5 rounded-xl border border-[#c8a96a]/25 bg-[#c8a96a]/[0.04] px-3 py-2.5 text-xs leading-snug">
      <VipPill spend={spend} className="mt-px" />
      <span className="text-white/70">
        {`$${Math.round(spend).toLocaleString('en-US')} on paid-off and active trips. A good candidate for a complimentary upgrade: Edit trip, then Upgraded. VIP itself promises them nothing, so never offer a perk in its name.`}
      </span>
    </div>
  );
}

VipUpgradeNudge.propTypes = {
  userId: PropTypes.string,
  upgraded: PropTypes.bool,
  active: PropTypes.bool,
};
